<template>
     <!-- 编辑单位用户 -->
     <el-dialog title="账户" width="25%" :visible.sync="dialogVisible" :show-close="false" :close-on-click-modal="false" destroy-on-close>
        <el-form :model="accountInfo" ref="accountForm" :rules="rules" size="small">
          <el-form-item label="账户名" :inline="true" class="znk_form_item" prop="userName">
            <el-input v-model="accountInfo.userName" :disabled="true" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机号" :inline="true" class="znk_form_item" prop="phone">
            <el-input v-model="accountInfo.phone" :disabled="true" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="微信OpenId" :inline="true" class="znk_form_item" prop="openId">
            <el-input v-model="accountInfo.openId" :disabled="true" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" :inline="true" class="znk_form_item" prop="email">
            <el-input v-model="accountInfo.email" placeholder="请输入电子邮箱" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="单位" :inline="true" class="znk_form_item" prop="unitName">
            <el-input v-model="accountInfo.unitName" placeholder="请输入单位名称" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="单位纳税号" :inline="true" class="znk_form_item" prop="unitTaxCode">
            <el-input v-model="accountInfo.unitTaxCode" placeholder="请输入单位纳税号" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeDialog">取 消</el-button>
          <el-button size="small" @click="saveAccountFunc()" type="primary" :loading="loading">确 定</el-button>
        </div>
      </el-dialog>  
</template>

<script>
import { getInfo,storeAccountInfo } from "@/cookie";
import { Message,MessageBox } from 'element-ui';
import { editorAccount } from "@/api/account";

export default {
  name: "AccountDialog",
  props: {
    dialogVisible: false
  },
  data(){
    return {
      rules: {},
      loading:false,
      accountInfo : {
        id: '',
        email : '-',
        openId: '',
        phone:'',
        unitName:'',
        unitTaxCode:'',
        userName:''
      },
    }
  },
  mounted(){
     let info_ = getInfo();
     this.accountInfo = {...info_};
     this.accountInfo.id = info_.uid;
  },
  created() {

  },
  watch : {
    
  },
  methods: {
    
    //打开新增用户弹窗
    closeDialog(){
      this.$emit('close');
    },

    //保存用户信息
    saveAccountFunc(){
      let this_ = this;
      let param = {...this_.accountInfo}
      this_.loading = true;
      editorAccount(param).then(res => {
          this_.loading = false;
          if(res.code == 200){
              Message.success('编辑成功'); 
              storeAccountInfo(this_.accountInfo.email,this_.accountInfo.unitName,this_.accountInfo.unitTaxCode);
              this_.$emit('close');
          } else {
              Message.error(res.msg);
          }
      });
    },

    
  },
};
</script>

<style>
.znk_form_item {
  margin-bottom: 5px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/AccountDialog.vue